import { render, staticRenderFns } from "./TripsIcon.vue?vue&type=template&id=35ea0194"
import script from "./TripsIcon.vue?vue&type=script&lang=ts"
export * from "./TripsIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports